/**
 * Store module - State management for Adyen checkout
 * This module provides a centralized state store for the Adyen checkout process
 */

var store = {
    // Checkout configuration object
    checkoutConfiguration: {
        environment: window.Configuration ? window.Configuration.environment : 'test',
        clientKey: window.adyenClientKey || '',
        locale: window.Configuration ? window.Configuration.locale : 'en-US',
        countryCode: window.countryCode ? window.countryCode : 'US',
        paymentMethodsConfiguration: {},
        onChange: null,
        onAdditionalDetails: null,
        showPayButton: false
    },

    // Adyen SFRA 25+ aligns paymentMethodsConfiguration at top level
    paymentMethodsConfiguration: {},

    // Form validation state
    formErrorsExist: false,

    // PayPal specific state
    paypalTerminatedEarly: false,

    // Component state
    componentsObj: {},

    // Gift card state
    addedGiftCards: [],

    // Partial payments state
    partialPaymentsOrderObj: {
        remainingAmountFormatted: '',
        totalDiscountedAmount: ''
    },

    // Adyen order data state
    adyenOrderDataCreated: false,

    // Payment state
    selectedMethod: null,
    selectedPayment: {
        stateData: null,
        isValid: false
    },
    brand: null,
    isValid: false,
    selectedPaymentIsValid: false,

    /**
     * Update selected payment method data
     * @param {string} method - Payment method identifier
     * @param {string} key - Property to update
     * @param {*} value - Value to set
     */
    updateSelectedPayment: function (method, key, value) {
        if (!this.selectedPayment) {
            this.selectedPayment = {};
        }
        this.selectedPayment[key] = value;
    },

    MASKED_CC_PREFIX: '************'
};

module.exports = store;
